import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  AuthService,
  ClientService,
  IChangePasswordDto,
  IClient,
  ToastService,
} from 'src/app/core';
import { MustMatch } from 'src/app/core/validators/compare.validator';

@Component({
  selector: 'ic-change-password',
  templateUrl: './change-password.component.html',
})
export class ChangePasswordComponent implements OnInit {
  public formErrors: any = {};
  public changePasswordForm: FormGroup;
  public clientConfig: IClient;

  constructor(
    private readonly fb: FormBuilder,
    private readonly authService: AuthService,
    private readonly toastService: ToastService,
    private readonly clientService: ClientService,
    public readonly activeDialog: NgbActiveModal
  ) {
    this.clientConfig = this.clientService.currentClientValue;
  }

  ngOnInit() {
    this.changePasswordForm = this.fb.group(
      {
        oldPassword: ['', [Validators.required, Validators.maxLength(30)]],
        password: ['', [Validators.required, Validators.maxLength(30)]],
        confirmPassword: ['', [Validators.required, Validators.maxLength(30)]],
      },
      {
        validator: MustMatch('password', 'confirmPassword'),
      }
    );

    // This forces validation.
    Object.keys(this.changePasswordForm.controls).forEach((key) => {
      this.changePasswordForm.get(key).markAsTouched();
    });

    this.changePasswordForm.valueChanges.subscribe((changes) => {
      Object.keys(changes).forEach((controlName) => {
        const control = this.changePasswordForm.controls[controlName];
        this.formErrors[controlName] =
          (control.touched || control.dirty) && control.errors ? 'error' : null;
      });
    });
  }

  closeDialog() {
   this.activeDialog.close();
  }

  get fc() {
    return this.changePasswordForm.controls;
  }

  changePassword() {
    const model: IChangePasswordDto = {
      ...this.changePasswordForm.value,
    };

    this.authService.changePassword(model).subscribe(
      (x) => {
        if (x.isSuccess) {
          this.toastService.showSuccess('Password changed successfully');
          this.closeDialog();
        } else {
          this.toastService.showError(x.errors[0]);
        }
      },
      (err) => {
        this.toastService.showError(err.exceptionMessage || err.message);
      }
    );
  }
}
